module.exports = __webpack_public_path__ + "img/EnviarIcon.6a484d26.svg";